/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 02/08/2019.
 */

import {Component, Input} from '@angular/core';

/**
 * Component for LemKen Note
 */
@Component({
  selector: 'mo-lemken-note',
  templateUrl: './mo-lemken-note.component.html',
  styleUrls: ['./mo-lemken-note.component.scss']
})
export class MoLemkenNoteComponent {
  /**
   * The note.
   */
  private _note: number;
  /**
   * Note to display
   */
  private _noteUI: string = '';

  /**
   * Constructor
   */
  constructor() { }

  /**
   * Getter.
   */
  @Input()
  public get note(): number {
    return this._note;
  }

  /**
   * Setter
   * @param value
   */
  public set note(value: number) {
    this._note = value;
    console.log(this._note);
    switch (this._note) {
      case 0:
      case undefined:
      case null:
        this._noteUI = '<img src="assets/images/smiley-0.png" Class="smileyNote" />';
        break;
      case 1:
        this._noteUI = '<img src="assets/images/smiley-1.png" Class="smileyNote" />';
        break;
      case 2:
        this._noteUI = `<img src="assets/images/smiley-1.png" Class="smileyNote" />
                        <img src="assets/images/smiley-1.png" Class="smileyNote" />`;
        break;
      default:
        this._noteUI = '';
        break;
    }
  }

  /**
   * Getter note UI
   */
  public get noteUI(): string {
    return this._noteUI;
  }
}
